import {Moment} from 'moment-timezone'

import {useCurrentScheduleQuery} from './useCurrentScheduleQuery'

interface UseScheduleItemQueryParams {
  plantId: string
  id?: string
  range: [Moment, Moment]
}

export const useScheduleItemQuery = ({plantId, id, range}: UseScheduleItemQueryParams) => {
  return useCurrentScheduleQuery({
    plantId,
    range,
    enabled: id !== undefined,
    select: (schedule) => (id ? schedule.schedules[id] : undefined)
  })
}
